module.exports = __webpack_public_path__ + "static/media/wa-bushfire-alerts.b8d09b67.png";